import profImage from "../images/profImage2.png";

const teamMembers = [
  {
    id: 1,
    name: "Dr. Tariq Abbas",
    image: profImage,
    details: `MBBS, IMRCS(Ire.), FEBPS, CAB GPS, FEAPU(Int.), PhD (Cand.),
      Department of Health Science and Technology, The Faculty of
      Medicine, Aalborg, Denmark. Pediatric Urologist, Hamad General
      Hospital, Doha, Qatar. Assistant Professor, Weil-Cornell Medical
      College-Qatar. Clinical Lecturer, College of Medicine, Qatar
      University.Dr. Tariq Abbas, MD, PhD (Cand.) is a Pediatric Urology Specialist
      at Sidra Medicine, Qatar. He is affiliated with Weill Cornell
      Medical College-Qatar, and has a special interest in
      hypospadiology starting from molecular studies, tissue
      engineering, animal experiments, clinical trials, to artificial
      intelligence.`,
  },
];

export default teamMembers;
